module.exports = __webpack_public_path__ + "img/arrow-method-payment-right.a7cfd645.svg";